<template>
  <form
    action=""
    novalidate
    @submit.prevent="validateBeforeSubmit"
    class="has-text-left"
  >
    <div
      class="field"
      :class="{
        'input-error':
          (!$v.credentials.username.$required ||
            !$v.credentials.username.$email) &&
          $v.credentials.username.$error
      }"
    >
      <label class="label" for="emailInput">E-mail</label>
      <input
        type="email"
        id="emailInput"
        name="emailInput"
        class="input"
        autofocus
        v-model="$v.credentials.username.$model"
      />
      <b-tooltip
        label="Campo requerido"
        type="is-danger"
        v-if="
          (!$v.credentials.username.$required ||
            !$v.credentials.username.$email) &&
            $v.credentials.username.$error
        "
      >
        <span class="error-icon has-text-danger"
          ><i class="mdi mdi-alert-circle"></i
        ></span>
      </b-tooltip>
    </div>
    <div
      class="field"
      :class="{
        'input-error':
          !$v.credentials.password.$required && $v.credentials.password.$error
      }"
    >
      <label class="label" for="passwordInput">Senha</label>
      <input
        type="password"
        id="passwordInput"
        name="passwordInput"
        class="input"
        v-model="$v.credentials.password.$model"
      />
      <b-tooltip
        label="Campo requerido"
        type="is-danger"
        v-if="
          !$v.credentials.password.$required && $v.credentials.password.$error
        "
      >
        <span class="error-icon has-text-danger"
          ><i class="mdi mdi-alert-circle"></i
        ></span>
      </b-tooltip>
    </div>

    <button
      class="button is-fullwidth is-primary"
      type="submit"
      :disabled="$v.credentials.$invalid || isPendingAction"
      :class="{ 'is-loading': isPendingAction }"
    >
      Entrar
    </button>
  </form>
</template>

<script>
import AuthService from "../services/AuthService";
import NotificationsWrapper from "../helpers/NotificationsWrapper";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "LoginForm",
  data: () => ({
    credentials: {
      password: "",
      username: ""
    },
    isPendingAction: false
  }),
  validations: {
    credentials: {
      username: { required, email },
      password: { required }
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.isPendingAction = true;
      AuthService.login(this.credentials)
        .then(() => {
          this.$router.push({ name: "app" });
        })
        .catch(() => {
          NotificationsWrapper.error(
            "Não foi possível autenticar no momento. Verifique suas credenciais e tente novamente."
          );
        })
        .finally(() => {
          this.isPendingAction = false;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.options-holder {
  font-size: 14px;
}
</style>
